import { Message } from 'element-ui';
import { isNull, isUndefined, filter as filter$1, flatten, isPlainObject, uniq, omit, isArray } from 'lodash';
export { add, after, ary, assign, assignIn, assignInWith, assignWith, at, attempt, before, bind, bindAll, bindKey, camelCase, capitalize, castArray, ceil, chain, chunk, clamp, clone, cloneDeep, cloneDeepWith, cloneWith, compact, concat, cond, conforms, conformsTo, constant, countBy, create, curry, curryRight, debounce, deburr, defaultTo, defaults, defaultsDeep, defer, delay, difference, differenceBy, differenceWith, drop, dropRight, dropRightWhile, dropWhile, each, eachRight, endsWith, entries, entriesIn, eq, escape, escapeRegExp, every, extend, extendWith, fill, find, findIndex, findKey, findLast, findLastIndex, findLastKey, first, flatMap, flatMapDeep, flatMapDepth, flatten, flattenDeep, flattenDepth, flip, floor, flow, flowRight, forEach, forEachRight, forIn, forInRight, forOwn, forOwnRight, fromPairs, functions, functionsIn, get, groupBy, gt, gte, has, hasIn, head, identity, inRange, includes, indexOf, initial, intersection, intersectionBy, intersectionWith, invert, invertBy, invoke, invokeMap, isArguments, isArray, isArrayBuffer, isArrayLike, isArrayLikeObject, isBoolean, isBuffer, isDate, isElement, isEmpty, isEqual, isEqualWith, isError, isFinite, isFunction, isInteger, isLength, isMap, isMatch, isMatchWith, isNaN, isNative, isNil, isNull, isNumber, isObject, isObjectLike, isPlainObject, isRegExp, isSafeInteger, isSet, isString, isSymbol, isTypedArray, isUndefined, isWeakMap, isWeakSet, iteratee, join, kebabCase, keyBy, keys, keysIn, last, lastIndexOf, lowerCase, lowerFirst, lt, lte, map, mapKeys, mapValues, matches, matchesProperty, max, maxBy, mean, meanBy, memoize, merge, mergeWith, method, methodOf, min, minBy, mixin, negate, noop, now, nth, nthArg, omit, omitBy, once, orderBy, over, overArgs, overEvery, overSome, pad, padEnd, padStart, parseInt, partial, partialRight, partition, pick, pickBy, property, propertyOf, pull, pullAll, pullAllBy, pullAllWith, pullAt, random, range, rangeRight, rearg, reduce, reduceRight, reject, remove, repeat, replace, rest, result, reverse, round, sample, sampleSize, set, setWith, shuffle, size, slice, snakeCase, some, sortBy, sortedIndex, sortedIndexBy, sortedIndexOf, sortedLastIndex, sortedLastIndexBy, sortedLastIndexOf, sortedUniq, sortedUniqBy, split, spread, startCase, startsWith, stubArray, stubFalse, stubObject, stubString, stubTrue, subtract, sum, sumBy, tail, take, takeRight, takeRightWhile, takeWhile, tap, template, templateSettings, throttle, thru, times, toArray, toFinite, toInteger, toLength, toLower, toNumber, toPairs, toPairsIn, toPath, toPlainObject, toSafeInteger, toString, toUpper, transform, trim, trimEnd, trimStart, truncate, unary, unescape, union, unionBy, unionWith, uniq, uniqBy, uniqWith, uniqueId, unset, unzip, unzipWith, update, updateWith, upperCase, upperFirst, values, valuesIn, without, words, wrap, xor, xorBy, xorWith, zip, zipObject, zipObjectDeep, zipWith } from 'lodash';
import { Decimal } from 'decimal.js-light/decimal.min';

const isNullOrUndefined = arg => {
    return [isNull, isUndefined].some(v => v(arg));
};

const isEmptyString = arg => {
    return arg === '';
};

const isEmptyValue = arg => {
    return [isNull, isUndefined, isEmptyString].some(v => v(arg));
};

// 深拷贝
const deepClone = data => {
    return JSON.parse(JSON.stringify(data));
};

// 空数组 []
const isEmptyArray = arr => {
    return arr.length === 0;
};

// 空对象 {}
const isEmptyObject = obj => {
    return isEmptyArray(Object.keys(obj));
};

// 求和 [整数]
const summation = (arr = []) => {
    return arr.reduce((prev, cur) => {
        return prev + cur;
    }, 0);
};

// 求积 [整数]
const quadrature = (arr = []) => {
    return arr.reduce((prev, cur) => {
        return prev * cur;
    });
};

// 筛选对象
const filter = (data = {}, attrs = []) => {
    // https://lodash.com/docs/4.17.11#filter
    if (Array.isArray(data)) {
        return filter$1(data, attrs);
    }
    return attrs.reduce((prev, cur) => {
        prev[cur] = data[cur];
        return prev;
    }, {});
};

// 只保留对象的部分属性(删除之外的属性)
const reserveProperties = (data = {}, keys = []) => {
    Object.keys(data)
        .filter(v => !keys.includes(v))
        .forEach(v => {
            delete data[v];
        });
};

// 批量删除属性
const removeProperties = (data = {}, keys = []) => {
    keys.forEach(v => {
        delete data[v];
    });
};

// 批量删除属性值为空的属性
const removeEmptyProperties = (data = {}) => {
    Object.entries(data).forEach(([k, v]) => {
        if (isEmptyValue(v)) {
            delete data[k];
        }
    });
};

/**
 * 产生一个值全是空字符串的对象
 * input: ['a', 'b']
 * output: {
 *     a: '',
 *     b: ''
 * }
 */
const produceEmptyObject = (keys = [], emptyText = '') => {
    return flatten(keys).reduce((prev, cur) => {
        prev[cur] = emptyText;
        return prev;
    }, {});
};

const generateId = () => {
    let d = +new Date();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        // eslint-disable-next-line no-bitwise
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        // eslint-disable-next-line no-bitwise
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
};

const queryParse = (queryString = '') => {
    let query;
    if (queryString.startsWith('?')) {
        query = queryString.substring(1);
    } else {
        query = queryString;
    }
    if (isEmptyString(query)) {
        return {};
    }
    return query.split('&').reduce((prev, cur) => {
        const [k, v = null] = cur.split('=');
        const val = isNull(v) ? v : decodeURIComponent(v);
        if (isUndefined(prev[k])) {
            prev[k] = val;
        } else {
            prev[k] = flatten([prev[k], val]);
        }
        return prev;
    }, {});
};

const queryStringify = (params = {}) => {
    return Object.entries(params || {})
        .reduce((prev, cur) => {
            const [k, v] = cur;
            if (isUndefined(v)) {
                return prev;
            }
            if (isNull(v)) {
                prev.push(k);
            } else {
                const list = flatten([v])
                    .filter(v2 => {
                        return !isUndefined(v2);
                    })
                    .map(v2 => {
                        const val = encodeURIComponent(v2);
                        return isNull(v2) ? k : [k, val].join('=');
                    });
                prev.push(...list);
            }
            return prev;
        }, [])
        .join('&');
};

const B = window.B || {};
B.uid = () => {
    return Math.random()
        .toString(36)
        .slice(2);
};
B.uuid = () => B.uid() + +new Date() + B.uid();
window.B = B;

const getOpener = () => {
    try {
        const oldParent = window.opener;
        if (oldParent) {
            return oldParent;
        }
    } catch (e) {
        /* 错了就错了吧 */
    }

    return null;
};

// 刷新页面
const reload = () => {
    window.location.reload();
};

// 关闭页面
const close = () => {
    window.close();
};

// 获取 search 参数
const getParams = (key = '') => {
    const params = queryParse(window.location.search);
    if (key === '') {
        return params;
    }
    return params[key];
};

const processCallback = args => {
    const fn = args[args.length - 1];
    if (typeof fn === 'function') {
        args.pop();
        const param = args[1] || {};
        param.router_callback_id = B.uuid();
        const uuid = param.router_callback_id;
        B[uuid] = fn;
    }
};

// 拼接url
const stringifyUrl = (url = '', params = {}) => {
    const args = Object.entries(params).reduce((prev, [k, v]) => {
        if (!isNullOrUndefined(v) && v !== '') {
            prev[k] = v;
        }
        return prev;
    }, {});
    if (isEmptyObject(args)) {
        return url;
    }
    return [url, queryStringify(args)].join('?');
};

// 跳转页面
// export const linkTo = (url = '', params = {}, isNewTab = false) => {
const linkTo = (url = '', params = {}, options = {}) => {
    const defaultOptions = {
        target: '_self', // a 标签属性
        isNewTab: false, // 是否在新 Tab打开（窗口、tab页）
        rel: 'noreferrer', // a 标签属性
        download: '' // a 标签属性
    };
    let computedOptions;
    if (isPlainObject(options)) {
        computedOptions = {
            ...defaultOptions,
            ...options
        };
    } else {
        // 兼容旧版：第三个参数 isNewTab = false | true
        computedOptions = {
            ...defaultOptions,
            isNewTab: !!options
        };
    }
    if (computedOptions.isNewTab) {
        computedOptions.target = '_blank';
    }
    const { target, rel, download } = computedOptions;
    const href = stringifyUrl(url, params);
    const elmentA = document.createElement('a');
    elmentA.target = target;
    elmentA.href = href;
    if (rel) {
        elmentA.rel = rel;
    }
    if (download) {
        if (download === true) {
            elmentA.setAttribute('download', '');
        } else {
            elmentA.setAttribute('download', download);
        }
    }
    elmentA.setAttribute('hidden', 'hidden');
    document.body.appendChild(elmentA);
    elmentA.click();
    document.body.removeChild(elmentA);
};

const open = (...args) => {
    // (pathname, [param, [hash, ]] callback])
    processCallback(args);
    window.open(stringifyUrl(...args));
};

// 解析 url
const parseUrl = (url = '') => {
    const elmentA = document.createElement('a');
    elmentA.href = url;
    return filter(elmentA, ['protocol', 'host', 'pathname', 'port', 'search', 'hash']);
};

// 没有副作用的 callback
function cb(...args) {
    const opener = getOpener();

    const callbackId = getParams('router_callback_id');
    if (!callbackId || !opener) {
        return null;
    }
    const fn = opener.B[callbackId];
    if (typeof fn !== 'function') {
        return null;
    }

    return fn(...args);
}

const callback = (...args) => {
    const callbackId = getParams('router_callback_id');
    if (!callbackId) {
        Message.error('只有使用 router.open 打开的页面才能使用 router.callback');
        return null;
    }
    const opener = getOpener();

    if (!opener) {
        Message.error('页面已失效，请重新打开！');
        return null;
    }
    const fn = opener.B[callbackId];
    if (typeof fn !== 'function') {
        Message.error('页面已失效，请重新打开！'); // 父页面刷新导致丢失callback
        return null;
    }
    return fn(...args);
};

function openBlank() {
    const win = global.open('', '_blank');
    return {
        goto(...args) {
            // (pathname, [param, [hash, ]] callback])
            processCallback(args);
            if (win) {
                win.location.href = stringifyUrl(...args);
            }
        },
        close() {
            if (win) {
                win.close();
            }
        }
    };
}

/**
 * 根据 url获取完整 url
 * @param {*} url
 * 举例
 * getFullUrl('edit.html?action=detail&costNo=KX201810260002&id=712')
 * "http://manager.mall.dev.sankuai.com/supplier/discount/order/edit.html?action=detail&costNo=KX201810260002&id=712"
 */
function getFullUrl(url) {
    if (!url) {
        return '';
    }
    const a = document.createElement('a');
    a.href = url;
    return a.href;
}

/**
 * 添加别名
 * @param {*} url
 * http://manager.mall.dev.sankuai.com/supplier/payment/manage.html -> http://manager.mall.dev.sankuai.com/supplier-alias/payment/manage.html
 */
function addUrlAlias(url) {
    const excludeUrls = ['/data/'];
    if (
        excludeUrls.findIndex(eu => {
            return url.indexOf(eu) >= 0;
        }) >= 0
    ) {
        return url;
    }

    if (/^\/([a-zA-Z]+)-alias\//.test(parseUrl(url).pathname)) {
        return url;
    }
    return url.replace(/\/([a-zA-Z]+)\//, '/$1-alias/');
}

/**
 * 去掉别名
 * @param {*} url
 * http://manager.mall.dev.sankuai.com/supplier-alias/payment/detail.html?paymentId=1980 -> http://manager.mall.dev.sankuai.com/supplier/payment/detail.html?paymentId=1980
 */
function delUrlAlias(url) {
    return url.replace(/\/([a-zA-Z]+)-alias\//, '/$1/');
}

if (!window.location.origin) {
    window.location.origin = [window.location.protocol, '//', window.location.hostname, window.location.port ? `:${window.location.port}` : ''].join('');
}

/**
 * [只封装最简单的get/post请求, 不做任何拓展]
 * @param  {String} url  [请求地址]
 * @param  {Object} args [fetch 的第二个参数]
 * @return {promise}      []
 */
const ajax = (url = '', args = {}) => {
    const {
        method = 'GET', // 'GET', 'POST'
        data = {}, // 参数
        dataType = 'json' // 'json', 'text'
    } = args;
    let fetchUrl = url;
    if (!url.startsWith('http')) {
        const { origin, protocol } = window.location;
        fetchUrl = [origin, url].join('/');
        if (url.startsWith('/')) {
            fetchUrl = [origin, url].join('');
        }
        if (url.startsWith('//')) {
            fetchUrl = [protocol, url].join('');
        }
    }
    if (method === 'GET') {
        return fetch(stringifyUrl(fetchUrl, data), { method }).then(res => {
            return res[dataType]();
        });
    }
    if (method === 'POST') {
        return fetch(fetchUrl, {
            method,
            body: JSON.stringify(data)
        }).then(res => {
            return res[dataType]();
        });
    }
};

ajax.get = (url = '', data = {}, dataType = 'json') => {
    return ajax(url, {
        method: 'GET',
        data,
        dataType
    });
};

ajax.post = (url = '', data = {}, dataType = 'json') => {
    return ajax(url, {
        method: 'POST',
        data,
        dataType
    });
};

const cookies = document.cookie
    .split('; ')
    .filter(v => v)
    .reduce((prev, cur) => {
        const [k, v] = cur.split('=');
        prev[k] = decodeURIComponent(v);
        return prev;
    }, {});

const cookie = {
    get(key) {
        return key ? cookies[key] : cookies;
    }
};

// 重复数组
const isUniq = (arr = []) => {
    return uniq(arr).length === arr.length;
};

// 将数据中的空值('', undefined, null)替换为默认值
const formatEmptyToDefault = (data = {}, formater = {}) => {
    Object.entries(data).forEach(([k, v]) => {
        Object.entries(formater).forEach(([k2, v2]) => {
            if (k2 === k) {
                if (v === '' || v == null) {
                    data[k] = v2;
                }
            }
        });
    });
};

// 将对象转换为数组
const convertObjectToArray = (data = {}, propKey = '') => {
    if (!propKey) {
        throw new Error('Missing required arguments: "propKey"');
    }
    return Object.entries(data).reduce((prev, cur) => {
        const [k, v] = cur;
        prev.push({
            ...v,
            [propKey]: k
        });
        return prev;
    }, []);
};

// 将数组转换为对象
const convertArrayToObject = (data = [], propKey = '') => {
    if (!propKey) {
        throw new Error('Missing required arguments: "propKey"');
    }
    return data.reduce((prev, cur) => {
        prev[cur[propKey]] = omit(cur, [propKey]);
        return prev;
    }, {});
};

// 加法
const plus = (x, y = 0) => {
    if (Array.isArray(x)) {
        return x.reduce((prev, cur) => {
            return Decimal(prev)
                .add(cur || 0)
                .toNumber();
        }, 0);
    }
    return Decimal(x || 0)
        .add(y || 0)
        .toNumber();
};

// 减法
const minus = (x, y) => {
    return Decimal(x || 0)
        .sub(y || 0)
        .toNumber();
};

// 乘法
const multiply = (x, y = 1) => {
    if (Array.isArray(x)) {
        return x.reduce((prev, cur) => {
            return Decimal(prev)
                .mul(cur || 0)
                .toNumber();
        }, 1);
    }
    return Decimal(x || 0)
        .mul(y || 0)
        .toNumber();
};

// 除法
const divide = (x, y = 1) => {
    return Decimal(x || 0)
        .div(y || 0)
        .toNumber();
};

// toFixed
const toFixed = (x, digit) => {
    return Decimal(x || 0).toFixed(digit);
};

// 下载文件
const download = (url = '', params = {}) => {
    const elmentA = document.createElement('a');
    const downloadUrl = stringifyUrl(url, params)
        .replace(/^http:\/\/s3plus.sankuai.com(:80)?\//, 'https://s3plus.sankuai.com/')
        .replace(/^http:\/\/mss.sankuai.com(:80)?\//, 'https://mss.sankuai.com/'); // http :80 -> https
    elmentA.href = downloadUrl;
    elmentA.download = downloadUrl;
    // https 页面下载 http协议在新窗口打开
    if (window.location.protocol === 'https:' && downloadUrl.startsWith('http://')) {
        elmentA.target = '_blank';
    }
    elmentA.click();
};

const hasClass = (el, cls) => {
    if (!el || !cls) {
        return false;
    }
    if (cls.indexOf(' ') !== -1) {
        throw new Error('className should not contain space.');
    }
    if (el.classList) {
        return el.classList.contains(cls);
    }
    return ` ${el.className} `.indexOf(` ${cls} `) > -1;
};

const addClass = (el, cls) => {
    if (!el) {
        return;
    }
    let curClass = el.className;
    const classes = (cls || '').split(' ');

    for (let i = 0, j = classes.length; i < j; i++) {
        const clsName = classes[i];
        if (!clsName) {
            continue; // eslint-disable-line
        }

        if (el.classList) {
            el.classList.add(clsName);
        } else if (!hasClass(el, clsName)) {
            curClass += ` ${clsName}`;
        }
    }
    if (!el.classList) {
        el.className = curClass;
    }
};

const removeClass = (el, cls) => {
    if (!el || !cls) {
        return;
    }
    const classes = cls.split(' ');
    let curClass = ` ${el.className} `;

    for (let i = 0, j = classes.length; i < j; i++) {
        const clsName = classes[i];
        if (!clsName) {
            continue; // eslint-disable-line
        }

        if (el.classList) {
            el.classList.remove(clsName);
        } else if (hasClass(el, clsName)) {
            curClass = curClass.replace(` ${clsName} `, ' ');
        }
    }
    if (!el.classList) {
        el.className = curClass.trim();
    }
};

// 通过 value 获取 label
const getLabelByValue = (value, data = [], emptyText = '--') => {
    const temp = data.find(v => v.value === value);
    if (temp) {
        return temp.label;
    }
    return emptyText;
};

// 将 json 转换成 optionList
const convertJsonToOptionList = (data = {}) => {
    return Object.entries(data).reduce((prev, [k, v]) => {
        prev.push({
            value: k,
            label: v
        });
        return prev;
    }, []);
};

// 通过 label 获取 value
const getValueByLabel = (label, data = [], emptyText = '--') => {
    let tempData = data;
    if (isPlainObject(data)) {
        tempData = convertJsonToOptionList(data);
    }
    const temp = tempData.find(v => v.label === label);
    if (temp) {
        return temp.value;
    }
    return emptyText;
};

// import { ajax } from './ajax';
/**
 * [获取 portal 配置]
 * 主页: http://portm.sankuai.com/page/portm-horn/index.html
 * 示例1: http://portal-portm.meituan.com/horn/v1/modules/vss/test
 * 示例2: http://portal-portm.meituan.com/horn/v1/modules/vss/prod
 * @param  {String} mod [必传; portal源: 例如 'vss', 'base'等]
 * @return {Function(key)}     []
 */

const CachePromise = {};

const fetchPortal = (mod = '') => {
    const isProd = ['beta', 'staging', 'production'].includes(process.env.NODE_ENV);
    const urlPrefix = '//portal-portm.meituan.com/horn/v1/modules';
    const apiName = isProd ? 'prod' : 'test';
    const url = [urlPrefix, mod, apiName].join('/');
    let startTime = Date.now();
    if (!CachePromise[mod]) {
        // CachePromise[mod] = ajax.get(url);
        CachePromise[mod] = fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(res => {
            if (res.status >= 200 && res.status < 300) {
                sendCatApi(url, 0, Date.now() - startTime);
            } else {
                sendCatApi(url, res.status, Date.now() - startTime);
            }
            return res;
        })
        .then(res => res.json());
    }
    return (key = '') => {
        return CachePromise[mod].then(res => {
            return key ? res[key] : res;
        });
    };
};

function sendCatApi(url, code, responseTime) {
    if (window.Owl) {
        try {
            let statusCode = code;

            if ([undefined, null].includes(statusCode)) {
                statusCode = 10001;
            } else if (+statusCode === 0) {
                statusCode = 10000;
            }
            window.Owl.addApi({
                name: url,
                statusCode,
                responseTime
            });
        } catch (e) {}
    }
}

/*
示例1:
const collaborators = await fetchPortal('vss')('collaborators');

示例2:
fetchPortal('vss')('collaborators').then(res => {
   // ...
});
 */

// 获取 cssText
const getCssText = (cssom = {}) => {
    const eleDiv = document.createElement('div');
    Object.entries(cssom).forEach(([k, v]) => {
        eleDiv.style[k] = v;
    });
    return eleDiv.style.cssText;
};

// 日期格式化
const WeekTextMap = ['天', '一', '二', '三', '四', '五', '六'];

// YYYY-MM-DD
// YYYY-MM-DD HH:mm
// YYYY-MM-DD HH:mm:ss
const formatTime = (date, format = 'yyyy-MM-dd', invalidText = '--') => {
    if (+date <= 0) {
        return invalidText;
    }
    const dt = new Date(+date);
    const parse = {
        yyyy: dt.getFullYear(),
        MM: dt.getMonth() + 1,
        dd: dt.getDate(),
        HH: dt.getHours(),
        mm: dt.getMinutes(),
        ss: dt.getSeconds(),
        星期: `星期${WeekTextMap[dt.getDay()]}`
    };

    parse.YYYY = parse.yyyy;
    parse.DD = parse.dd;

    Object.entries(parse).forEach(([k, v]) => {
        parse[k] = String(v).padStart(2, 0);
    });

    return Object.entries(parse).reduce((prev, [k, v]) => {
        return prev.replace(k, v);
    }, format);
};

/**
 * 处理日期范围
 *
 * {
 *     dateRangeTime: {
 *         startKey: 'sTime',
 *         endKey: 'eTime',
 *         empty: -1
 *     }
 * }
 *
 * 或
 *
 * [
 *     {
 *         prop: 'dateRangeTime',
 *         startKey: 'sTime',
 *         endKey: 'eTime',
 *         empty: -1
 *     }
 * ]
 */
const formateDateRangeTime = (data = {}, formatter = {}) => {
    let innerFormatter = formatter;
    if (isArray(formatter)) {
        innerFormatter = convertArrayToObject(formatter, 'prop');
    }
    Object.entries(innerFormatter).forEach(([k, v]) => {
        const { startKey = '', endKey = '', empty = -1 } = v;
        // eslint-disable-next-line prefer-const
        let [startTime, endTime] = (data[k] || ['', '']).map(v2 => +new Date(v2) || 0);
        // 如果俩时间不为空且相等, 则加一天减一秒
        if (startTime && startTime === endTime) {
            endTime = startTime + (24 * 60 * 60 - 1) * 1000;
        }
        Object.assign(data, {
            [startKey]: startTime || empty,
            [endKey]: endTime || empty
        });
        delete data[k];
    });
};

const getDateRange = (range = '', optionConfig) => {
    const options = Object.assign({ type: 'timestamp', operate: 'pre', parseTime: true }, optionConfig);
    if (!['timestamp', 'date'].includes(options.type) || !['pre', 'next'].includes(options.operate)) {
        throw new Error('[getDateRange] : options参数不合法');
    }
    const MP = {
        D: 24 * 3600 * 1000,
        H: 3600 * 1000,
        M: 60 * 1000,
        S: 1000
    };

    const now = new Date();
    const target = String(range)
        .trim()
        .replace(/(\d+)([D,H,M,S]{1})/i, (v, num, unit) => {
            if (options.operate === 'pre') {
                return +now - num * MP[unit.toUpperCase()];
            }
            return +now + num * MP[unit.toUpperCase()];
        });

    const result = options.operate === 'pre' ? [new Date(+target), now] : [now, new Date(+target)];

    if (options.parseTime) {
        // 格式化日期的time为0：00 - 23：59：59
        result[0].setHours(0, 0, 0, 0);
        result[1].setHours(23, 59, 59, 0);
    }

    if (options.type === 'timestamp') {
        return result.map(date => +date);
    }

    return result.map(date => new Date(date));
};

const reportLx = (...args) => {
    if (window.LXAnalytics) {
        window.LXAnalytics(...args);
    }
};

export { WeekTextMap, addClass, addUrlAlias, ajax, callback, cb, close, convertArrayToObject, convertJsonToOptionList, convertObjectToArray, cookie, deepClone, delUrlAlias, divide, download, fetchPortal, filter, formatEmptyToDefault, formatTime, formateDateRangeTime, generateId, getCssText, getDateRange, getFullUrl, getLabelByValue, getOpener, getParams, getValueByLabel, hasClass, isEmptyArray, isEmptyObject, isEmptyString, isEmptyValue, isNullOrUndefined, isUniq, linkTo, minus, multiply, open, openBlank, parseUrl, plus, produceEmptyObject, quadrature, queryParse, queryStringify, reload, removeClass, removeEmptyProperties, removeProperties, reportLx, reserveProperties, getParams as search, stringifyUrl, summation, toFixed };
